import { enableProdMode, importProvidersFrom, provideZonelessChangeDetection } from '@angular/core';

import { environment } from './environments/environment';
import { routes } from './app.routes';

import { PreloadAllModules, provideRouter, RouteReuseStrategy, withPreloading } from '@angular/router';
import { IonicRouteStrategy, IonicModule } from '@ionic/angular';
import { CognitoConfigService, StorageService, AuthModule } from '@uoa/auth';
import { AppAuthConfigService, AppStorageService } from './app/core/services';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideErrorPages } from '@uoa/error-pages';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppComponent } from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        provideZonelessChangeDetection(),importProvidersFrom(BrowserModule, IonicModule.forRoot(), AuthModule, IonicStorageModule.forRoot()),
        provideErrorPages(),
        provideRouter(routes, withPreloading(PreloadAllModules)),
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        { provide: CognitoConfigService, useClass: AppAuthConfigService },
        { provide: StorageService, useClass: AppStorageService },
    ]
}).catch((err) => console.error(err));
